import { FC } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router';
import { useActiveClientContext } from 'store/active-client';
import { buildClientEntity } from 'utils/helpers/client';
import API from 'core/Api';
import { IResponseData } from 'types/api';
import InnerWrapper from '../../InnerWrapper';
import EditForm from './components/EditForm';
import { IRole } from '../types';

const Screen: FC = () => {
  const { id } = useParams<{ id: string | undefined }>();
  const { client } = useActiveClientContext();
  const { isLoading, error, data } = useQuery<IRole, Error>(
    [buildClientEntity('role', client), { id }],
    (): Promise<IRole> =>
      API.get<IResponseData<IRole>>(`roles?id=${id}`).then(res => {
        if (res.data && res.data.items.length === 0) throw new Error('Не съществува такава роля');
        return res.data.items[0];
      }),
    {
      retry: false,
    }
  );

  return (
    <InnerWrapper
      isLoading={isLoading}
      error={error}
    >
      {data && <EditForm role={data} />}
    </InnerWrapper>
  );
};

export default Screen;
